import { useReactFlow } from '@xyflow/react'
import { Grid } from 'lucide-react'
import { useShallow } from 'zustand/shallow'
import { useFlowStore } from '@/stores/flow-store'
import { useInsertNode } from '@/hooks/use-insert-node'
import { AVAILABLE_NODES } from '../../..'
import { BuilderNode } from '../../../types'
import SidebarPanelWrapper from '../../components/sidebar-panel-wrapper'
import { NodePreviewDraggable } from './components/node-preview-draggable'

export default function AvailableNodesPanel() {
  const [setActivePanel] = useFlowStore(
    useShallow((s) => [s.actions.sidebar.setActivePanel])
  )

  const insertNode = useInsertNode()
  const { getNodes } = useReactFlow()

  return (
    <SidebarPanelWrapper className='min-h-[500px] overflow-y-auto'>
      <div className='mt-4 flex flex-col items-center p-4 text-center'>
        <div className='flex size-12 items-center justify-center rounded-full bg-primary'>
          <Grid className='size-6 text-white' />
        </div>

        <div className='mt-4 text-balance font-medium'>Nós Disponíveis</div>
        <div className='text-light-50/40 mt-1 w-2/3 text-xs font-medium leading-normal'>
          Arraste e solte nós para construir seu fluxo de chatbot
        </div>
      </div>

      <div className='grid flex-1 grid-cols-1 gap-4 p-4'>
        {AVAILABLE_NODES.map((node) => {
          const isSingleton =
            node.type === BuilderNode.START || node.type === BuilderNode.END
          const disabled =
            isSingleton && getNodes().some((n) => n.type === node.type)
          return (
            <NodePreviewDraggable
              key={node.type}
              type={node.type}
              icon={node.icon}
              title={node.title}
              description={node.description}
              setActivePanel={setActivePanel}
              insertNode={insertNode}
              disabled={disabled}
            />
          )
        })}
      </div>
    </SidebarPanelWrapper>
  )
}
